import { read } from "Utils/Helpers/LocalStorage";
import instance from "http/Manager";

export const getPatients = (data) => {
    if(data) {
        return instance.get(`/patients/search/`, {
            params: {
                id: read('main-local'),
                ...properties('page', data.page),
                ...properties('limit', data.limit),
                ...properties('search', data.data),
            }
        });
    } else {
        return instance.get(`/patients/search/`, {
            params: { id: read('main-local') }
        });
    }
};

export const saveNewPatient = (name, nationalCode, identificationCode, mobile) => {
    const data = {
        name, nationalCode, identificationCode, mobile,
        clinic: read('main-local'),
    }
    return instance.post(`/patients`, data);
};

export const editPatient = (id, name, nationalCode, identificationCode, mobile) => {
    const data = { id, name, nationalCode, identificationCode, mobile }
    return instance.put(`/patients`, data);
};

export const deletePatient = (id, force) => {
    return instance.delete(`/patients`, {
        params: {
            id: read('main-local'),
            sid: id,
            force
        }
    });
};

const properties = (key, item) => {
    if(item) return { [key]: item }
    else return null;
};